import React, { FC, ReactElement, useRef } from "react";
import { Carousel } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./CarouselImageSlider.css";

interface SliderItem {
  id: number;
  name: string;
  url: string;
  perfumeId?: number;
}

interface CarouselImageSliderProps {
  items: SliderItem[];
}

const CarouselImageSlider: FC<CarouselImageSliderProps> = ({ items }): ReactElement => {
  const carouselRef = useRef<any>(null);

  if (!items?.length) return <></>;

  return (
    <div className="flipkart-slider">
      <Carousel
        autoplay
        autoplaySpeed={3500}
        dots
        ref={carouselRef}
        className="flipkart-carousel"
        draggable        /* mouse drag on desktop */
        swipeToSlide     /* touch swipe on mobile */
        touchMove        /* smoother mobile swipe */
        pauseOnHover
      >
        {items.map((item) => (
          <div key={item.id} className="carousel-item-wrapper">
            {item.perfumeId ? (
              <Link to={`/product/${item.perfumeId}`} className="carousel-link">
                <img
                  src={item.url}
                  alt={item.name}
                  className="carousel-image"
                  loading="lazy"
                />
              </Link>
            ) : (
              /* no product linked — render as plain image */
              <div className="carousel-link">
                <img
                  src={item.url}
                  alt={item.name}
                  className="carousel-image"
                  loading="lazy"
                />
              </div>
            )}
          </div>
        ))}
      </Carousel>

      {/* Desktop-only arrows — hidden on mobile via CSS */}
      <button
        className="carousel-arrow left"
        onClick={() => carouselRef.current?.prev()}
        aria-label="Previous slide"
      >
        <LeftOutlined />
      </button>

      <button
        className="carousel-arrow right"
        onClick={() => carouselRef.current?.next()}
        aria-label="Next slide"
      >
        <RightOutlined />
      </button>
    </div>
  );
};

export default CarouselImageSlider;